import { http } from "../ConnectApi/ConnectApi";

export async function BRLASellHistoryController() {
  

  try {
    const response = await http.get(`tftc/sell/brla/history`, {
      withCredentials: true
    });

    
    return response;
  } catch (error: any) {
    console.error('Error during register:', error.response?.data || error.message);
    throw error;
  }
}
